/**
 * Created by vladislav on 04/01/22
 */

const CupComponent = function (unit, options) {
    UnitComponent.call(this, unit);

    const data = unit.getData();

    this.missionType = data.cup.mission !== undefined ? Mission.CompoundType(data.cup.mission, cleverapps.meta.selectedLocationId()) : undefined;
    this.amount = options.amount === undefined ? data.cup.amount : options.amount;

    this.firstRewardIndex = options.fri;

    this.fixedAmount = (options.fa === undefined ? data.cup.fixedAmount : options.fa) || 0;

    if (this.isEmpty()) {
        setTimeout(this.remove.bind(this, true), 0);
    }
};

CupComponent.prototype = Object.create(UnitComponent.prototype);
CupComponent.prototype.constructor = CupComponent;

CupComponent.prototype.onUpdateState = function () {
    if (this.view) {
        this.view.restoreState(true);
    }
};

CupComponent.prototype.save = function (data) {
    data.amount = this.amount;

    if (this.unit.getData().cup.fixedAmount) {
        data.fa = this.fixedAmount;
    }

    data.fri = this.firstRewardIndex;
};

CupComponent.prototype.handleClick = function () {
    this.unit.squeeze();

    if (this.missionType && !cleverapps.missionManager.findRunningMission(this.missionType)) {
        cleverapps.centerHint.createTextHint(Messages.get(`MissionNotStarted.${Missions[this.missionType].name}`));
    } else {
        this.spendCharge();
    }

    return true;
};

CupComponent.prototype.remove = function (silent) {
    if (silent) {
        this.unit.onRemove();
    } else {
        this.onDestruction();
        this.unit.onDestruction();
    }
    this.unit.remove(true);
};

CupComponent.prototype.getFixedCupData = function () {
    const data = cleverapps.clone(this.unit.getData().cup, true);

    const units = [];
    let probabilities = [];
    let sum = 0;

    for (let i = 0; i < data.units.length; i++) {
        if (data.fixed.includes(data.units[i].code)) {
            sum += data.probabilities[i];
            probabilities.push(data.probabilities[i]);
            units.push(data.units[i]);
        }
    }
    probabilities = probabilities.map((probability) => probability / sum);

    data.units = units;
    data.probabilities = probabilities;

    return data;
};

CupComponent.prototype.getRewardUnits = function () {
    let data = this.unit.getData().cup;
    if (this.amount <= this.fixedAmount) {
        data = this.getFixedCupData();
    }

    if (this.firstRewardIndex !== undefined) {
        const fri = this.firstRewardIndex;
        delete this.firstRewardIndex;

        const firstRewardUnit = data.firstRewards[fri];
        if (firstRewardUnit) {
            return firstRewardUnit;
        }
    }

    const units = Prizes.Generate([data], {
        listOnly: true
    });
    return [units[PseudoRandom.GET().pickOne(data.probabilities)]];
};

CupComponent.prototype.spendCharge = function () {
    if (this.unit.isLockedUnit()) {
        return;
    }
    if (!this.isEmpty()) {
        const units = this.getRewardUnits();

        const remains = Map2dLocation.currentLocation.spawn(units, this.unit, { radius: Map2d.RADIUS_SMALL, spawnSource: "cup" });
        if (remains.length > 0) {
            return;
        }

        units.forEach((spawned) => {
            cleverapps.metrics.logEvent(`cupspawn-${this.unit.code}${this.unit.stage}_${spawned.code}${spawned.stage}`);
        });

        if (this.fixedAmount && units.some((unit) => this.unit.getData().cup.fixed.includes(unit.code))) {
            this.fixedAmount--;
        }

        this.amount--;

        this.unit.save();

        if (this.isEmpty()) {
            this.remove();
        }

        this.onUpdateState();
    }
};

CupComponent.prototype.isFull = function () {
    return this.amount >= this.unit.getData().cup.amount;
};

CupComponent.prototype.isEmpty = function () {
    return this.amount < 1;
};

CupComponent.prototype.onDestruction = function () {
    if (this.view) {
        this.view.playDestruction();
    }
};

CupComponent.CanMerge = function (unit1, unit2) {
    const cup1 = unit1.findComponent(CupComponent);

    if (!cup1) {
        return true;
    }

    const cup2 = unit2.findComponent(CupComponent);

    if (!cup2) {
        return true;
    }

    return cup1.isFull() && cup2.isFull();
};

CupComponent.IsCup = function (unit) {
    const data = Families[unit.code] && Families[unit.code].units[unit.stage];
    return Boolean(data && data.cup);
};

CupComponent.ListPrizeProb = function (unit) {
    const cup = Families[unit.code].units[unit.stage].cup;

    const types = {};
    let total = 0;

    cup.units.forEach((entry, index) => {
        const prize = Prizes.Generate([entry], { listOnly: true })[0];
        if (!prize) {
            return;
        }

        const key = `${prize.code}_${prize.stage}`;
        types[key] = types[key] || { code: prize.code, stage: prize.stage, prob: 0 };
        types[key].prob += cup.probabilities[index];
        total += cup.probabilities[index];
    });

    return {
        minAmount: cup.amount,
        maxAmount: cup.amount,
        types: Object.values(types)
            .map((type) => ({ ...type, prob: Math.round(type.prob / total * 10000) / 100 }))
            .sort((a, b) => b.prob - a.prob)
    };
};

CupComponent.IsCup = function (unit) {
    const data = Families[unit.code] && Families[unit.code].units[unit.stage];
    return Boolean(data && data.cup);
};

CupComponent.ListPrizeProb = function (unit) {
    const cup = Families[unit.code].units[unit.stage].cup;

    const types = {};
    let total = 0;

    cup.units.forEach((entry, index) => {
        const prize = Prizes.Generate([entry], { listOnly: true })[0];
        if (!prize) {
            return;
        }

        const key = `${prize.code}_${prize.stage}`;
        types[key] = types[key] || { code: prize.code, stage: prize.stage, prob: 0 };
        types[key].prob += cup.probabilities[index];
        total += cup.probabilities[index];
    });

    return {
        minAmount: cup.amount,
        maxAmount: cup.amount,
        types: Object.values(types)
            .map((type) => ({ ...type, prob: Math.round(type.prob / total * 10000) / 100 }))
            .sort((a, b) => b.prob - a.prob)
    };
};
